import { SUPPORT_EMAIL } from '@constants';
import { contextNamesSelector, userSelector } from '@selectors';
import { useSelector } from '@hooks';
import { capitalize } from '@utils';

export const useMailContext = () => {
  const { username } = useSelector(userSelector);
  const { organizationName, clusterName, projectName } =
    useSelector(contextNamesSelector);

  const formattedUsername = capitalize(username);

  const bodyObject = {
    Username: formattedUsername,
    Organization: organizationName,
    Cluster: clusterName,
    Project: projectName,
    URL: `${window.location.origin}${window.location.pathname}`,
  };

  const subject = `${formattedUsername} Support Request`;
  const body = encodeURIComponent(
    Object.entries(bodyObject)
      .map(([name, value]) => (value ? `${name}: ${value}` : null))
      .filter(Boolean)
      .join('\n'),
  );
  const mailto = `mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`;

  return { mailto, body, subject };
};
